import React, {Component} from 'react'
import {injectIntl, defineMessages} from 'react-intl'
import { UNIT_OF_MEASURE } from "../../state/product/Types"

class SelectUnitOfMeasure extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            unitOfMeasure: this.props.value || '',
            name: this.props.name || '',
            required: this.props.required || false,
            emptyLabel: this.props.emptyLabel || 'choose',
        }

        const defaultCallback = () => {
        }
        this.onChange = this.props.onChange || defaultCallback
        this.handleChange = this.handleChange.bind(this)
        this.sortUnits = this.sortUnits.bind(this)

        this.supportedUnitOfMeasure = [
            [UNIT_OF_MEASURE.PIECE],
            [UNIT_OF_MEASURE.INCH],
            [UNIT_OF_MEASURE.FOOT],
            [UNIT_OF_MEASURE.YARD],
            [UNIT_OF_MEASURE.MILE],
            [UNIT_OF_MEASURE.CENTIMETER],
            [UNIT_OF_MEASURE.METER],
            [UNIT_OF_MEASURE.KILOMETER],
            [UNIT_OF_MEASURE.SQUARE_METER],
            [UNIT_OF_MEASURE.CUBIC_METER],
            [UNIT_OF_MEASURE.LITER],
            [UNIT_OF_MEASURE.MILLILITER],
            [UNIT_OF_MEASURE.GRAM],
            [UNIT_OF_MEASURE.KILOGRAM],
            [UNIT_OF_MEASURE.TON],
            [UNIT_OF_MEASURE.OUNCE],
            [UNIT_OF_MEASURE.POUND],
            [UNIT_OF_MEASURE.GALLON],
            [UNIT_OF_MEASURE.MINUTE],
            [UNIT_OF_MEASURE.HOUR],
            [UNIT_OF_MEASURE.HOURS_MINUTE],
            [UNIT_OF_MEASURE.DAY],
            [UNIT_OF_MEASURE.MONTH],
            [UNIT_OF_MEASURE.QUARTER],
            [UNIT_OF_MEASURE.YEAR],
            [UNIT_OF_MEASURE.TRAVEL],
            [UNIT_OF_MEASURE.PARTICIPANT],
            [UNIT_OF_MEASURE.USER],
            [UNIT_OF_MEASURE.PAGE],
            [UNIT_OF_MEASURE.PERSON],
            [UNIT_OF_MEASURE.GIGABYTE],
            [UNIT_OF_MEASURE.MEGABYTE],
            [UNIT_OF_MEASURE.ASSET],
            [UNIT_OF_MEASURE.EPISODE],
            [UNIT_OF_MEASURE.TALENT],
            [UNIT_OF_MEASURE.SQUARE_FOOT],
            [UNIT_OF_MEASURE.SERVING],
        ]

        this.messages = defineMessages({
            "choose": {
                id: 'common.unit_of_measure.input.choose_label',
                defaultMessage: 'Choose',
            },
            "none": {
                id: 'common.unit_of_measure.input.none_label',
                defaultMessage: 'None',
            },
            [UNIT_OF_MEASURE.PIECE]: {
                id: 'common.unit_of_measure.input.piece_label',
                defaultMessage: 'Unit',
            },
            [UNIT_OF_MEASURE.INCH]: {
                id: 'common.unit_of_measure.input.inch_label',
                defaultMessage: 'Inch',
            },
            [UNIT_OF_MEASURE.FOOT]: {
                id: 'common.unit_of_measure.input.foot_label',
                defaultMessage: 'Foot',
            },
            [UNIT_OF_MEASURE.YARD]: {
                id: 'common.unit_of_measure.input.yard_label',
                defaultMessage: 'Yard',
            },
            [UNIT_OF_MEASURE.MILE]: {
                id: 'common.unit_of_measure.input.mile_label',
                defaultMessage: 'Mile',
            },
            [UNIT_OF_MEASURE.CENTIMETER]: {
                id: 'common.unit_of_measure.input.centimeter_label',
                defaultMessage: 'Centimeter',
            },
            [UNIT_OF_MEASURE.METER]: {
                id: 'common.unit_of_measure.input.meter_label',
                defaultMessage: 'Meter',
            },
            [UNIT_OF_MEASURE.KILOMETER]: {
                id: 'common.unit_of_measure.input.kilometer_label',
                defaultMessage: 'Kilometer',
            },
            [UNIT_OF_MEASURE.SQUARE_METER]: {
                id: 'common.unit_of_measure.input.square_meter_label',
                defaultMessage: 'Square meter',
            },
            [UNIT_OF_MEASURE.CUBIC_METER]: {
                id: 'common.unit_of_measure.input.cubic_meter_label',
                defaultMessage: 'Cubic meter',
            },
            [UNIT_OF_MEASURE.LITER]: {
                id: 'common.unit_of_measure.input.liter_label',
                defaultMessage: 'Liter',
            },
            [UNIT_OF_MEASURE.MILLILITER]: {
                id: 'common.unit_of_measure.input.milliliter_label',
                defaultMessage: 'Milliliter',
            },
            [UNIT_OF_MEASURE.GRAM]: {
                id: 'common.unit_of_measure.input.gram_label',
                defaultMessage: 'Gram',
            },
            [UNIT_OF_MEASURE.KILOGRAM]: {
                id: 'common.unit_of_measure.input.kilogram_label',
                defaultMessage: 'Kilogram',
            },
            [UNIT_OF_MEASURE.TON]: {
                id: 'common.unit_of_measure.input.ton_label',
                defaultMessage: 'Ton',
            },
            [UNIT_OF_MEASURE.OUNCE]: {
                id: 'common.unit_of_measure.input.ounce_label',
                defaultMessage: 'Ounce',
            },
            [UNIT_OF_MEASURE.POUND]: {
                id: 'common.unit_of_measure.input.pound_label',
                defaultMessage: 'Pound',
            },
            [UNIT_OF_MEASURE.GALLON]: {
                id: 'common.unit_of_measure.input.gallon_label',
                defaultMessage: 'Gallon',
            },
            [UNIT_OF_MEASURE.MINUTE]: {
                id: 'common.unit_of_measure.input.minute_label',
                defaultMessage: 'Minute',
            },
            [UNIT_OF_MEASURE.HOUR]: {
                id: 'common.unit_of_measure.input.hour_label',
                defaultMessage: 'Hour',
            },
            [UNIT_OF_MEASURE.HOURS_MINUTE]: {
                id: 'common.unit_of_measure.input.hours-minutes_label',
                defaultMessage: 'Hours & Minutes',
            },
            [UNIT_OF_MEASURE.DAY]: {
                id: 'common.unit_of_measure.input.day_label',
                defaultMessage: 'Day',
            },
            [UNIT_OF_MEASURE.MONTH]: {
                id: 'common.unit_of_measure.input.month_label',
                defaultMessage: 'Month',
            },
            [UNIT_OF_MEASURE.QUARTER]: {
                id: 'common.unit_of_measure.input.quarter_label',
                defaultMessage: 'Quarter',
            },
            [UNIT_OF_MEASURE.YEAR]: {
                id: 'common.unit_of_measure.input.year_label',
                defaultMessage: 'Year',
            },
            [UNIT_OF_MEASURE.TRAVEL]: {
                id: 'common.unit_of_measure.input.travel_label',
                defaultMessage: 'Travel',
            },
            [UNIT_OF_MEASURE.PARTICIPANT]: {
                id: 'common.unit_of_measure.input.participant_label',
                defaultMessage: 'Participant',
            },
            [UNIT_OF_MEASURE.USER]: {
                id: 'common.unit_of_measure.input.user_label',
                defaultMessage: 'User',
            },
            [UNIT_OF_MEASURE.PAGE]: {
                id: 'common.unit_of_measure.input.page_label',
                defaultMessage: 'Page',
            },
            [UNIT_OF_MEASURE.PERSON]: {
                id: 'common.unit_of_measure.input.person_label',
                defaultMessage: 'Person',
            },
            [UNIT_OF_MEASURE.GIGABYTE]: {
                id: 'common.unit_of_measure.input.gigabyte_label',
                defaultMessage: 'Gigabyte',
            },
            [UNIT_OF_MEASURE.MEGABYTE]: {
                id: 'common.unit_of_measure.input.megabyte_label',
                defaultMessage: 'Megabyte',
            },
            [UNIT_OF_MEASURE.ASSET]: {
                id: 'common.unit_of_measure.input.asset_label',
                defaultMessage: 'Asset',
            },
            [UNIT_OF_MEASURE.EPISODE]: {
                id: 'common.unit_of_measure.input.episode_label',
                defaultMessage: 'Episode',
            },
            [UNIT_OF_MEASURE.TALENT]: {
                id: 'common.unit_of_measure.input.talent_label',
                defaultMessage: 'Talent',
            },
            [UNIT_OF_MEASURE.SQUARE_FOOT]: {
                id: 'common.unit_of_measure.input.square_foot_label',
                defaultMessage: 'Square foot',
            },
            [UNIT_OF_MEASURE.SERVING]: {
                id: 'common.unit_of_measure.input.serving_label',
                defaultMessage: 'Serving',
            }
        })
    }

    handleChange(event) {
        this.setState({
            unitOfMeasure: event.target.value
        }, () => {
            this.onChange(this.state.unitOfMeasure)
        })
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            unitOfMeasure: nextProps.value || '',
        })
    }

    componentDidMount() {
    }

    required() {
        if (this.props.required)
            return required
    }

    sortUnits(a, b) {
        const ma = this.props.intl.formatMessage(this.messages[a]).toLowerCase()
        const mb = this.props.intl.formatMessage(this.messages[b]).toLowerCase()
        if (ma < mb) {
            return -1;
        }
        if (ma > mb) {
            return 1;
        }
        return 0;
    }

    render() {
        return <select
            id={this.state.name}
            name={this.state.name}
            value={this.state.unitOfMeasure}
            onChange={this.handleChange}
            className="form-control"
            required={this.state.required}
        >
            <option value="" disabled={this.state.required} selected>
                {this.props.intl.formatMessage(this.messages[this.state.emptyLabel])}
            </option>
            {this.supportedUnitOfMeasure.sort(this.sortUnits).map((unitOfMeasure, index) => {
                return <option key={index} value={unitOfMeasure}>
                    {this.props.intl.formatMessage(this.messages[unitOfMeasure])}
                </option>
            })}
        </select>
    }
}

export default injectIntl(SelectUnitOfMeasure)





// WEBPACK FOOTER //
// ./src/common/unit-of-measure/select.component.jsx